import loadable from '@loadable/component';
import React from 'react';

import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';

const pageDataLoadingAPI = getPageDataLoadingAPI();

const AllBrandsPage = loadable(() => import(/* webpackChunkName: "AllBrandsPage" */ '../containers/AllBrandsPage/AllBrandsPage'));
const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CartPage = loadable(() => import(/* webpackChunkName: "CartPage" */ '../containers/CartPage/CartPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const SeoCarPage = loadable(() => import(/* webpackChunkName: "SeoCarPage" */ '../containers/SeoPages/SeoCarPage'));
const SeoPackageIndexPage = loadable(() => import(/* webpackChunkName: "SeoPackageIndexPage" */ '../containers/SeoPages/SeoPackageIndexPage'));
const AISearchPage = loadable(() => import(/* webpackChunkName: "AISearchPage" */ '../containers/AISearchPage/AISearchPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const SellerDashboardPage = loadable(() => import(/* webpackChunkName: "SellerDashboardPage" */ '../containers/SellerDashboardPage/SellerDashboardPage'));
const ManageServicesPage = loadable(() => import(/* webpackChunkName: "ManageServicesPage" */ '../containers/ManageServicesPage/ManageServicesPage'));
const ManageLinksPage = loadable(() => import(/* webpackChunkName: "ManageLinksPage" */ '../containers/ManageLinksPage/ManageLinksPage'));
const IntegrationsPage = loadable(() => import(/* webpackChunkName: "IntegrationsPage" */ '../containers/IntegrationsPage/IntegrationsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));
const OrderPaymentPage = loadable(() => import(/* webpackChunkName: "OrderPaymentPage" */ '../containers/OrderPaymentPage/OrderPaymentPage'));
const SellerEconomyPage = loadable(() => import(/* webpackChunkName: "SellerEconomyPage" */ '../containers/SellerEconomyPage/SellerEconomyPage'));
const FreightPage = loadable(() => import(/* webpackChunkName: "FreightPage" */ '../containers/FreightPage/FreightPage'));
const ManageFavouritesPage = loadable(() => import(/* webpackChunkName: "ManageFavouritesPage" */ '../containers/ManageFavouritesPage/ManageFavouritesPage'));
const LemonadoStatisticsPage = loadable(() => import(/* webpackChunkName: "LemonadoStatisticsPage" */ '../containers/StatisticsPage/LemonadoStatisticsPage'));
const SubUsersPage = loadable(() => import(/* webpackChunkName: "SubUsersPage" */ '../containers/SubUsersPage/SubUsersPage'));
const SetPasswordSubUserPage = loadable(() => import(/* webpackChunkName: "SetPasswordSubUserPage" */ '../containers/SetPasswordSubUserPage/SetPasswordSubUserPage'));
const SavedSearchesPage = loadable(() => import(/* webpackChunkName: "SavedSearchesPage" */ '../containers/SavedSearchesPage/SavedSearchesPage'));
const AccessRequestPage = loadable(() => import(/* webpackChunkName: "AccessRequestPage" */ '../containers/AccessRequestPage/AccessRequestPage'));
const SubscriptionsPage = loadable(() => import(/* webpackChunkName: "SubscriptionsPage" */ '../containers/SubscriptionsPage/Subscriptionspage'));
const NoAccessPage = loadable(() => import(/* webpackChunkName: "NoAccessPage" */ '../containers/NoAccessPage/NoAccessPage'));
const WheelplaceCreateListingPage = loadable(() => import(/* webpackChunkName: "WheelplaceCreateListingPage" */ '../containers/WheelplaceCreateListingPage/WheelplaceCreateListingPage'));
const KeywordDashboardPage = loadable(() => import(/* webpackChunkName: "KeywordDashboardPage" */ '../containers/KeywordDashboardPage/KeywordDashboardPage'));
const CommissionDashboardPage = loadable(() => import(/* webpackChunkName: "CommissionDashboardPage" */ '../containers/CommissionDashboardPage/CommissionDashboardPage'));
const ReceiptObjectionsPage = loadable(() => import(/* webpackChunkName: "ReceiptObjectionsPage" */ '../containers/ReceiptObjectionsPage/ReceiptObjectionsPage'));
const EmailSuppressionsPage = loadable(() => import(/* webpackChunkName: "EmailSuppressionsPage" */ '../containers/EmailSuppressionsPage/EmailSuppressionsPage'));
const PayoutQueuePage = loadable(() => import(/* webpackChunkName: "PayoutQueuePage" */ '../containers/PayoutQueuePage/PayoutQueuePage'));
const ListingLookupAdminPage = loadable(() => import(/* webpackChunkName: "ListingLookupAdminPage" */ '../containers/ListingLookupAdminPage/ListingLookupAdminPage'));
const WheelplaceBulkUploadPage = loadable(() => import(/* webpackChunkName: "WheelplaceBulkUploadPage" */ '../containers/WheelplaceBulkUploadPage/WheelplaceBulkUploadPage'));
const WheelplaceBuildPackagesPage = loadable(() => import(/* webpackChunkName: "WheelplaceBuildPackagesPage" */ '../containers/WheelplaceBuildPackagesPage/WheelplaceBuildPackagesPage'));
const WheelplaceProgramWizardPage = loadable(() => import(/* webpackChunkName: "WheelplaceProgramWizardPage" */ '../containers/WheelplaceProgramWizardPage/WheelplaceProgramWizardPage'));
const LandingHero = loadable(() =>
  import(
    /* webpackChunkName: "LandingHero" */ '../containers/WP/LandingPage/LandingHero'
  )
);

// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));
const ManageWarehousePage = loadable(() => import(/* webpackChunkName: "ManageWarehousePage" */ '../containers/ManageWarehousePage/ManageWarehousePage'));
const ManageStoragePage = loadable(() => import(/* webpackChunkName: "ManageStoragePage" */ '../containers/ManageStoragePage/ManageStoragePage'));
const StorageCardPage = loadable(() => import(/* webpackChunkName: "StorageCardPage" */ '../containers/StorageCardPage/StorageCardPage'));

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
  'SubUsersPage',
  'AccessRequestPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// A listing UUID, written as a path-to-regexp param pattern. It pins the :id
// segment of the breadcrumb listing route so that route only matches real
// listing URLs. Note that it must not contain parentheses: path-to-regexp
// cannot parse nested groups inside a param pattern.
const UUID_PATH_PATTERN =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig) => {
  const SearchPage = layoutConfig.searchPage?.variantType === 'map'
    ? SearchPageWithMap
    : SearchPageWithGrid;
  const ListingPage = layoutConfig.listingPage?.variantType === 'carousel'
    ? ListingPageCarousel
    : ListingPageCoverPhoto;

  return [
    {
      path: '/',
      name: 'LandingPage',
      // component: LandingHero,
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      // Cart (Varukorg) page — client-only (cart lives in localStorage),
      // works logged out, no SSR loadData.
      path: '/varukorg',
      name: 'CartPage',
      component: CartPage,
    },
    {
      path: '/p/stripe-dashboard',
      name: 'StripeDashboardPage',
      auth: true,
      permission: "transactions",
      // Ekonomi (P25009-496): one row per order, from the Sharetribe
      // transactions, for every seller — card and own payment alike. It replaced
      // the Stripe-shaped SellerFinancePage tabs. Route name is kept as
      // 'StripeDashboardPage' so all existing NamedLinks keep working.
      component: SellerEconomyPage,
      loadData: pageDataLoadingAPI.SellerEconomyPage.loadData,
    },
    {
      /* Abandoned duplicate of the statistics page: its only content was a
       * commented-out Lemonado iframe, so anyone reaching this URL got a blank
       * page. Nothing in the app links here — the nav points at
       * LemonadoStatisticsPage — so it redirects there rather than being kept
       * alive as a guaranteed empty page. P25009-387 AC-4.
       * The old component is still in the repo at
       * containers/StatisticsPage/StatisticsPage.js if the Stripe-native view
       * is ever wanted back. */
      path: '/p/statistics',
      name: 'StatisticsPage',
      auth: true,
      permission: "statistics",
      component: () => <NamedRedirect name="LemonadoStatisticsPage" />,
    },
    {
      path: '/p/lemonado-statistics',
      name: 'LemonadoStatisticsPage',
      auth: true,
      permission: "statistics",
      component: LemonadoStatisticsPage,
    },
    {
      path: '/admin/keywords',
      name: 'KeywordDashboardPage',
      auth: true,
      component: KeywordDashboardPage,
    },
    {
      /* Commission & leakage for enterprise dealers (P25009-422). `auth: true`
       * only requires a login; the admin check is the page's own, and the API
       * behind it refuses a non-admin regardless — so a curious logged-in user
       * gets the "access denied" card and nothing else. */
      path: '/admin/provision',
      name: 'CommissionDashboardPage',
      auth: true,
      component: CommissionDashboardPage,
    },
    {
      /* Objections to self-billed receipts (P25009-435 Track A2). Same
       * arrangement as the two admin pages above: `auth: true` only requires a
       * login, the admin check is the page's own, and the API behind it refuses
       * a non-admin regardless. */
      path: '/admin/invandningar',
      name: 'ReceiptObjectionsPage',
      auth: true,
      component: ReceiptObjectionsPage,
    },
    {
      /* Addresses mail is no longer sent to — hard bounces and spam complaints
       * — with the user behind each, so support can phone them (P25009-436).
       * Same arrangement as the admin pages above: `auth: true` only requires
       * a login, the admin check is the page's own, and the API behind it
       * refuses a non-admin regardless. */
      path: '/admin/epostsparrar',
      name: 'EmailSuppressionsPage',
      auth: true,
      component: EmailSuppressionsPage,
    },
    {
      /* Seller payouts that need a person: approved orders whose seller has
       * not been paid, and "Betala ut order X", which runs the same payout
       * code as the daily job instead of a Stripe-dashboard payout that can
       * never be linked to an order (P25009-495). Same arrangement as the
       * admin pages above: `auth: true` only requires a login, the admin
       * check is the page's own, and the API refuses a non-admin regardless. */
      path: '/admin/utbetalningar',
      name: 'PayoutQueuePage',
      auth: true,
      component: PayoutQueuePage,
    },
    {
      /* Support's lookup by listing number or reg plate: every matching
       * listing, any seller, any state (P25009-512 BR-9). Same arrangement as
       * the admin pages above: `auth: true` only requires a login, the admin
       * check is the page's own, and the API refuses a non-admin regardless. */
      path: '/admin/annonsnr',
      name: 'ListingLookupAdminPage',
      auth: true,
      component: ListingLookupAdminPage,
    },
    {
      /* Public SEO landing pages. They live alongside the marketplace and
       * always link back into the live listings page (/annonser/...). The
       * data comes from the master car database (carFitment) via /api/seo. */
      path: '/dack/:make/:model',
      name: 'SeoTireModelPage',
      component: SeoCarPage,
      loadData: pageDataLoadingAPI.SeoTireModelPage.loadData,
    },
    {
      path: '/falgar/:make/:model',
      name: 'SeoRimModelPage',
      component: SeoCarPage,
      loadData: pageDataLoadingAPI.SeoRimModelPage.loadData,
    },
    {
      /* The AI-search answer pages (P25009-408). The index must stay ABOVE the
       * :make/:model route below — a two-segment path cannot match it, but
       * keeping them in this order makes the intent obvious and survives
       * someone later making the index take a parameter. */
      path: '/hjulpaket',
      name: 'SeoPackageIndexPage',
      component: SeoPackageIndexPage,
      loadData: pageDataLoadingAPI.SeoPackageIndexPage.loadData,
    },
    {
      path: '/hjulpaket/:make/:model',
      name: 'SeoPackageModelPage',
      component: SeoCarPage,
      loadData: pageDataLoadingAPI.SeoPackageModelPage.loadData,
    },
    {
      /* AI search as a third mode (P25009-447). The header's AI segment
       * pushes here with the buyer's question; the page turns it into
       * visible, removable filters grounded in real stock. */
      path: '/sok',
      name: 'AISearchPage',
      component: AISearchPage,
      loadData: pageDataLoadingAPI.AISearchPage.loadData,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    {
      /* Must come before the /annonser/:make catch-all so "skapa" isn't
       * swallowed as a car-make slug. */
      path: '/annonser/skapa',
      name: 'WheelplaceCreateListingPage',
      auth: true,
      permission: 'listings',
      component: WheelplaceCreateListingPage,
    },
    {
      /* Bulk upload import history for dealer accounts. */
      path: '/annonser/bulk-upload',
      name: 'WheelplaceBulkUploadPage',
      auth: true,
      permission: 'listings',
      component: WheelplaceBulkUploadPage,
    },
    {
      /* "Bygg paket" — reach engine: build wheelsets from CSV inventory. */
      path: '/annonser/bygg-paket',
      name: 'WheelplaceBuildPackagesPage',
      auth: true,
      permission: 'listings',
      component: WheelplaceBuildPackagesPage,
    },
    {
      /* "Hjulprogram" — one season program per dealer instead of hundreds of
       * package ads. Must stay above the /annonser/:make catch-all further
       * down, or "hjulprogram" is swallowed as a car-make slug. P25009-405. */
      path: '/annonser/hjulprogram',
      name: 'WheelplaceProgramWizardPage',
      auth: true,
      permission: 'listings',
      component: WheelplaceProgramWizardPage,
    },
    {
      /* Browse hub linking every brand page, every model page and the common
       * sizes. Must stay above the /annonser/:make catch-all below, or
       * "alla-marken" is swallowed as a car-make slug. No loadData: it renders
       * from the hosted category configuration, so the links are in the
       * server-rendered HTML. */
      path: '/annonser/alla-marken',
      name: 'AllBrandsPage',
      component: AllBrandsPage,
    },
    {
      path: '/annonser/:make/:model',
      name: 'SearchPageMakeModel',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/annonser/:make',
      name: 'SearchPageMake',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/annonser',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      // Clean, indexable tire-dimension landing page, e.g. /dack/205-55r16
      path: '/dack/:tireSize',
      name: 'TireDimensionPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      // Clean, indexable rim-dimension landing page, e.g. /falgar/5-112-18-tum
      path: '/falgar/:rimSize',
      name: 'RimDimensionPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      // Breadcrumb-style listing URL, e.g.
      // /l/hjul/audi/a3/vinterdack-audi-a3/691f2cda-8510-4098-85ba-2cc9383cc28a
      //
      // The UUID pattern on :id is what keeps this route apart from
      // EditListingStripeOnboardingPage, which also has five segments but ends
      // in "success"/"failure". For the same reason this entry must stay above
      // that one: <Switch> renders the first route that matches.
      path: `/l/:category/:make/:model/:slug/:id(${UUID_PATH_PATTERN})`,
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      // Legacy listing URL. Kept for good: older Google results, shared links
      // and the sitemap all point at it. The ListingPage component
      // 301-redirects it to the breadcrumb URL above.
      path: '/l/:slug/:id',
      name: 'ListingPageLegacy',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      permission: "transactions",
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/subscriptions',
      name: 'SubscriptionsPage',
      auth: true,
      component: SubscriptionsPage,
      // loadData: pageDataLoadingAPI.SubscriptionsPage.loadData,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      permission: "listings",
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      permission: "listings",
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/favorites',
      name: 'ManageFavouritesPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageFavouritesPage,
      loadData: pageDataLoadingAPI.ManageFavouritesPage.loadData,
    },
    {
      path: '/favorites/saved-queries',
      name: 'SavedQueriesPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: ManageFavouritesPage,
      loadData: pageDataLoadingAPI.ManageFavouritesPage.loadData,
    },
    {
      // Store profile with the shop name in the address, e.g.
      // /u/dackspecialisten-ab/691f2cda-8510-4098-85ba-2cc9383cc28a
      //
      // The slug is cosmetic — the page keys on the UUID — so a stale or wrong
      // slug still resolves and ProfilePage redirects it to the canonical one.
      // Private sellers are sent back to /u/:id: their pages are noindex for
      // GDPR reasons, so their name does not belong in the address.
      //
      // The UUID pattern on :id is what separates this from the two-segment
      // /u/:id below. Routes are exact by default, so neither can swallow the
      // other, but the pattern also keeps a nonsense third segment out.
      path: `/u/:slug/:id(${UUID_PATH_PATTERN})`,
      name: 'ProfilePageSlugged',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: ProfileSettingsPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup/:userType',
      name: 'SignupForUserTypePage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => {
        let tab = 'sales';
        if (typeof window !== 'undefined') {
          const mode = window.localStorage.getItem('buyerSellerMode');
          if (mode === 'buyer') tab = 'orders';
        }
        return <NamedRedirect name="InboxPage" params={{ tab }} />;
      },
    },
    {
      path: '/inbox/:tab/:id?',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id?',
      name: 'OrderPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: TransactionPage,
      loadData: (params, search, config) => pageDataLoadingAPI.TransactionPage.loadData({ ...params, tab: 'purchases' }, search, config),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/pay',
      name: 'OrderPaymentPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: OrderPaymentPage,
      loadData: (params, search, config) => pageDataLoadingAPI.TransactionPage.loadData({ ...params, tab: 'purchases' }, search, config),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: props => <NamedRedirect name="OrderPage" params={{ id: props.params?.id }} />,
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/sale/:id?',
      name: 'SalePage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: TransactionPage,
      loadData: (params, search, config) => pageDataLoadingAPI.TransactionPage.loadData({ ...params, tab: 'orders' }, search, config),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      /* Frakt (P25009-450): the booking queue, and per order the booking
       * screen — /frakt/:id mirrors the mockup's konto/frakt/WO-xxx. */
      path: '/frakt/:id?',
      name: 'FreightPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: FreightPage,
      loadData: pageDataLoadingAPI.FreightPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "transactions",
      component: props => <NamedRedirect name="SalePage" params={{ id: props.params?.id }} />,
    },
    {
      /* The seller's home (P25009-385). "Dina annonser" used to be where a
       * seller landed; BR-6 makes it a tool they open instead, so this page owns
       * the landing slot. Anyone still using /listings as a bookmark keeps
       * working — that route is unchanged. */
      path: '/oversikt',
      name: 'SellerDashboardPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "listings",
      component: SellerDashboardPage,
      loadData: pageDataLoadingAPI.SellerDashboardPage.loadData,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "listings",
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      // Seller add-on services (Tillval / Tjänster). Seller-only via the same
      // "listings" permission as ManageListingsPage. Reads currentUser from
      // state, so no loadData.
      path: '/services',
      name: 'ManageServicesPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "listings",
      component: ManageServicesPage,
    },
    {
      // Company links (Länkar): website, Google Business profile, booking
      // system. Same seller-only "listings" permission as the Tjänster tab.
      // Reads currentUser from state, so no loadData.
      path: '/links',
      name: 'ManageLinksPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "listings",
      component: ManageLinksPage,
    },
    {
      /* Integrationer (P25009-412): webhook endpoints, secrets and the
       * delivery log. "admin" because a sub-user acts inside the owner's
       * session, and this hands out secrets for the whole account. The page
       * and its API both answer "ingår i Enterprise" to everyone else. */
      path: '/integrationer',
      name: 'IntegrationsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: IntegrationsPage,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: PasswordChangePage,
    },
    // This page should not be available on Wheelplace
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    // This page should not be available on Wheelplace
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/account/subusers',
      name: 'SubUsersPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: SubUsersPage,
      loadData: pageDataLoadingAPI.SubUsersPage.loadData,
    },
    {
      path: '/bevakningar',
      name: 'SavedSearchesPage',
      auth: true,
      authPage: 'LoginPage',
      component: SavedSearchesPage,
      loadData: pageDataLoadingAPI.SavedSearchesPage.loadData,
    },
    {
      /* Förfrågningar (köpes annonser) was replaced by Bevakningar — P25009-371
       * BR-6. The route name is kept so that bookmarks, any link we missed, and
       * external inbound links land on the new page instead of a 404.
       *
       * BR-8, decided: the feature leaves the menus but its data stays. Nothing
       * is deleted — the köpes annonser are Sharetribe listings and are
       * untouched, and containers/BuyListingPage is still in the codebase, just
       * no longer routed. Restoring it is a one-line change here. */
      path: '/sökannonser',
      name: 'BuyListingPage',
      component: () => <NamedRedirect name="SavedSearchesPage" />,
    },
    {
      path: '/account/AccessRequestPage',
      name: 'AccessRequestPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "admin",
      component: AccessRequestPage,
      loadData: pageDataLoadingAPI.AccessRequestPage.loadData,
    },

    {
      path: '/subusers/set-password',
      name: 'SetPasswordSubUserPage',
      component: SetPasswordSubUserPage,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/no-access',
      name: 'NoAccessPage',
      component: NoAccessPage,
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/warehouse',
      name: 'ManageWarehousePage',
      auth: true,
      authPage: 'LoginPage',
      permission: "warehouse",
      component: ManageWarehousePage,
    },
    {
      /* Storage module ("Förvaring") — tire hotel + trade-in (P25009-344).
       * Reuses the existing `warehouse` permission: storage lives inside the
       * warehouses and needs the same per-warehouse sub-user access. */
      path: '/forvaring',
      name: 'ManageStoragePage',
      auth: true,
      authPage: 'LoginPage',
      permission: "warehouse",
      component: ManageStoragePage,
    },
    {
      /* The storage card (P25009-451): the read-only page a Förvaring row
       * opens, and the URL inside the QR code on the printed label. */
      path: '/forvaring/:id',
      name: 'StorageCardPage',
      auth: true,
      authPage: 'LoginPage',
      permission: "warehouse",
      component: StorageCardPage,
    },
  ];
};

export default routeConfiguration;
